import styled from 'styled-components'

const AllUsersContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export { AllUsersContainer }
